import { FLOATING_ELEMENT_PLACEMENT } from '../../../../../../constants/common'
import { stopPropagation } from '../../../../../../utils/events'
import Button, { BUTTON_HEIGHT_24 } from '../../../../../Button'
import { TableCellBase } from '../../../../../Table'

import { QA_NAME_LISTING_PUBLICATION_PRIMARY_ACTION } from './ListingProfilePublishingsActionsCell.constants'
import { getHasListingPublicationActionsMenu } from './ListingProfilePublishingsActionsCell.utils'
import { ListingProfilePublishingsActionsMenu } from './ListingProfilePublishingsActionsMenu'

import * as styles from './ListingProfilePublishingsActionsCell.module.css'

function ListingProfilePublishingsActionsCell({
  isMenuDisabled,
  menuTooltipContent,
  options,
  primary: {
    disabled: isPrimaryDisabled,
    label: primaryLabel,
    tooltipContent: primaryTooltipContent,
    value: primaryAction,
  },
  onCallAction,
  ...cellProps
}) {
  function handleClickPrimary() {
    onCallAction(primaryAction)
  }

  return (
    <TableCellBase
      {...cellProps}
      className={styles.ListingProfilePublishingsActionsCell}
      onClick={stopPropagation}
    >
      {primaryAction ? (
        <Button.Outlined
          disabled={isPrimaryDisabled}
          height={BUTTON_HEIGHT_24}
          isGrey={isPrimaryDisabled}
          qaName={QA_NAME_LISTING_PUBLICATION_PRIMARY_ACTION}
          showTextTooltip={!isPrimaryDisabled}
          text={primaryLabel}
          tooltip={isPrimaryDisabled ? primaryTooltipContent : null}
          tooltipPlacement={FLOATING_ELEMENT_PLACEMENT.top}
          onClick={handleClickPrimary}
        />
      ) : null}
      {getHasListingPublicationActionsMenu({ isMenuDisabled, options }) ? (
        <ListingProfilePublishingsActionsMenu
          isDisabled={isMenuDisabled}
          options={options}
          tooltipContent={menuTooltipContent}
          onCallAction={onCallAction}
        />
      ) : null}
    </TableCellBase>
  )
}

export default ListingProfilePublishingsActionsCell
